var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewPaymentType',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('PaymentTypeTable',{ref:"table",attrs:{"title":"Users"},on:{"addHealth":_vm.showPaymentTypeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }